import { CarModel } from "@/api/generated/BMWInterfaces"

export function formatLabel(value: number): string {
  if (value >= 1000000) {
    return `${(value / 1000000).toLocaleString()} מיליון`
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(0)} אלף`
  }
  return `${value}₪`
}

export function formatLabelString(value: number): string {
  if (value >= 1000) {
    return `${(value / 1000).toLocaleString(undefined, { maximumFractionDigits: 0 })} אלף`
  }
  return `${value.toLocaleString()}`
}

export function getPriceRange(cars: CarModel[]): {
  minPrice: number
  maxPrice: number
  midPrice: number
} {
  if (cars.length === 0) {
    return { minPrice: 0, maxPrice: 0, midPrice: 0 }
  }

  const prices = cars.map((car) => car.discountPrice || car.price)
  const minPrice = Math.min(...prices)
  const maxPrice = Math.max(...prices)

  return {
    minPrice,
    maxPrice,
    midPrice: (minPrice + maxPrice) / 2,
  }
}

export const slugify = (text: string): string => {
  return text
    .toString()
    .normalize("NFD") // split an accented letter in the base letter and the accent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // replace spaces with -
    .replace(/[^\w-]+/g, "") // remove all non-word chars
    .replace(/--+/g, "-") // replace multiple - with single -
    .replace(/^-+/, "") // trim - from start of text
    .replace(/-+$/, "") // trim - from end of text
}

export const isMobileOrTabletDevice = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor
  const mobileOrTabletRegex = new RegExp(
    [
      "Android",
      "webOS",
      "iPhone",
      "iPad",
      "iPod",
      "BlackBerry",
      "IEMobile",
      "Opera Mini",
      "Tablet",
    ].join("|"),
    "i",
  )
  const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1

  return mobileOrTabletRegex.test(userAgent) || isIPadOS
}

export const handleShare = async ({
  title,
  text,
  isCopiedToClipboard,
}: {
  title: string
  text: string
  isCopiedToClipboard: (copied: boolean) => void
}): Promise<void> => {
  const articleUrl = window.location.href

  if (isMobileOrTabletDevice() && navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url: articleUrl,
      })
      return
    } catch {
      // User canceled share or sharing failed, continue to clipboard fallback.
    }
  } else if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(articleUrl)
      isCopiedToClipboard(true)
      return
    } catch {
      isCopiedToClipboard(false)
      return
    }
  }
  console.error("Web Share API and Clipboard API are not supported in this browser.")
}
